/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../../__generated__/zeus/types';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
/** Application context requesting passwordless authentication. */
export type PasswordlessAppType =
  /** The production Opendoor buyer app. */
  | 'BUYER_APP'
  /** A development build of the Opendoor buyer app. */
  | 'BUYER_APP_DEV'
  /** The Opendoor Key agent app. */
  | 'KEY_AGENT';

/** Passwordless sign-in token to preserve through Key app installation. */
export type PasswordlessInstallResumeTokenCreateInput = {
  /** Existing passwordless sign-in token, up to 64 characters. */
  passwordlessToken: Types.Scalars['NonEmptyString']['input'];
};

/** Options for sending a passwordless sign-in link. */
export type SendPasswordlessSignInLinkInput = {
  /** Application context for the sign-in link; omitted when not app-specific. */
  appType?: PasswordlessAppType | null | undefined;
  /** URL the link should open after sign-in; omitted to use the default destination. */
  redirectUrl?: Types.Scalars['URL']['input'] | null | undefined;
  /** Account identifier for the sign-in link. */
  subject: SendPasswordlessSignInLinkSubjectInput;
};

/** Exactly one account identifier used to send a passwordless sign-in link. */
export type SendPasswordlessSignInLinkSubjectInput =
  {   /** Email address of the account to receive the sign-in link. */
  email: Types.Scalars['EmailAddress']['input']; passwordlessToken?: never; }
  |  { email?: never;   /** Existing passwordless token identifying the sign-in subject. */
  passwordlessToken: Types.Scalars['NonEmptyString']['input']; };

export type CreatePasswordlessInstallResumeTokenMutationVariables = Exact<{
  input: Types.PasswordlessInstallResumeTokenCreateInput;
}>;


export type CreatePasswordlessInstallResumeTokenMutation = { passwordlessInstallResumeTokenCreate:
    | { __typename: 'InstallResumeTokenCreation', token: Types.Scalars['NonEmptyString']['output'] | null }
    | { __typename: 'InvalidInputError' }
    | { __typename: 'NotFoundError' }
    | { __typename: 'UnauthorizedError' }
   };

export type SendPasswordlessSignInLinkMutationVariables = Exact<{
  input: Types.SendPasswordlessSignInLinkInput;
}>;


export type SendPasswordlessSignInLinkMutation = { sendPasswordlessSignInLink:
    | { __typename: 'CommandResult', success: Types.Scalars['Boolean']['output'] }
    | { __typename: 'InvalidInputError', message: Types.Scalars['String']['output'] }
    | { __typename: 'NotFoundError', message: Types.Scalars['String']['output'] }
    | { __typename: 'UnauthorizedError', message: Types.Scalars['String']['output'] }
   };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const CreatePasswordlessInstallResumeTokenDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation CreatePasswordlessInstallResumeToken($input: PasswordlessInstallResumeTokenCreateInput!) {
  passwordlessInstallResumeTokenCreate(input: $input) {
    __typename
    ... on InstallResumeTokenCreation {
      token
    }
  }
}
    `) as unknown as TypedDocumentString<CreatePasswordlessInstallResumeTokenMutation, CreatePasswordlessInstallResumeTokenMutationVariables>;
export const SendPasswordlessSignInLinkDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SendPasswordlessSignInLink($input: SendPasswordlessSignInLinkInput!) {
  sendPasswordlessSignInLink(input: $input) {
    __typename
    ... on CommandResult {
      success
    }
    ... on Error {
      message
    }
  }
}
    `) as unknown as TypedDocumentString<SendPasswordlessSignInLinkMutation, SendPasswordlessSignInLinkMutationVariables>;